// 这部分逻辑和组合式API版本一致，因为是Vue3通用API
import { createVNode, render } from 'vue'
import modalPopup from './modalPopup.vue'

// 创建挂载容器
const modalContainer = document.createElement('div')
modalContainer.id = 'modal-container'
document.body.appendChild(modalContainer)

/**
 * 函数式调用弹窗组件（选项式API适配版）
 * @param {Object} options 弹窗配置项
 * @returns {Object} 包含关闭弹窗的方法
 */
const openModal = (options = {}) => {
  // 关闭弹窗并销毁组件
  const closeModal = () => {
    render(null, modalContainer)
  }

  // 创建组件虚拟节点
  const vnode = createVNode(modalPopup, {
    visible: true,
    ...options,
    // 选项式API中通过$emit触发的事件，这里仍用onClose监听
    onClose: closeModal
  })

  // 渲染组件到DOM
  render(vnode, modalContainer)

  // 返回关闭方法供外部调用
  return {
    close: closeModal
  }
}

export default openModal